import { render } from "./NeedsInformationForm.vue?vue&type=template&id=2ea08228&scoped=true"
import script from "./NeedsInformationForm.vue?vue&type=script&lang=js"
export * from "./NeedsInformationForm.vue?vue&type=script&lang=js"

import "./NeedsInformationForm.vue?vue&type=style&index=0&id=2ea08228&scoped=true&lang=css"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea08228"]])

export default __exports__